import { createAction, props } from '@ngrx/store';
import { IRegulatoryResponse, ITermsAndConditions } from '../models/marketing-options.model';

export const loadGetRegulatory = createAction('[Regulatory] Load Get Regulatory');

export const loadGetRegulatorySuccess = createAction(
  '[Regulatory] Load Get Regulatory Success',
  props<{ response: ITermsAndConditions }>()
);

export const loadGetRegulatoryFailure = createAction('[Regulatory] Load Get Regulatory Failure', props<{ error: Error | any }>());
